import { render, staticRenderFns } from "./EthicalInvesting.vue?vue&type=template&id=3a212290&scoped=true&"
import script from "./EthicalInvesting.vue?vue&type=script&lang=js&"
export * from "./EthicalInvesting.vue?vue&type=script&lang=js&"
import style0 from "./EthicalInvesting.vue?vue&type=style&index=0&id=3a212290&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a212290",
  null
  
)

export default component.exports